import PropTypes from 'prop-types'

export const treasuryPropTypes = PropTypes.shape({
    credits: PropTypes.number,
    crystal: PropTypes.number,
    gold: PropTypes.number,
})



// WEBPACK FOOTER //
// ./propTypes.js